export enum VorvertragStatusValidationResult {
  VORVERTRAG_MANUELL_SEIT_MEHR_ALS_EINEM_JAHR_STORNIERT = 'VORVERTRAG_MANUELL_SEIT_MEHR_ALS_EINEM_JAHR_STORNIERT',
}
